
export const ROUTES = {
    AUTH: {
        LOGIN: "/login",
        SIGNUP: "/onboarding",
    },
    DEFAULT_AUTHENTICATED: "/builder",
    MAIN: {
        DASHBOARD: "/dashboard",
        CREATEPROJECT: "/create-project",
        ESCROW: "/escrow-account",
        TEAM: "/team-access-control",
        ANALYTICS: "/analytics",
        LEADS: "/leads",
        BANK: "/bank",
        INQUIRIES: "/inquiries",
        WALLET: "/wallet",
        GALLERY: "/gallery",
        SUBSCRIPTION: "/subscription",
        PAYMENT: "/payment",
        BUILDER: "/builder",
        BUILDERMANAGE: "/builder/:id/manage",
        BUILDERPROJECTS: "/builder/:id/projects",
        BUILDERHISTORY: "/builder/:id/history",
        BUILDERPROFILE: "/builder/:id/profile",
        PROJECTCOMPLIANCE: "/project-compliance",
        ESCROWPAYMENT: "/escrow-payment",
        BUYER: "/buyer",
        BUYERMANAGE: "/buyer/manage/:id",
        BUYERPROFILE: "/buyer/:id/profile",
        BROKER: "/broker",
        BROKERMANAGE: "/broker/manage/:id",
        BROKERRESSIGN: "/broker/:id/reassign",
        BROKERCOMMISSON: "/broker/:id/commission",
        LeadVisitTriage: "/lead-triage",
        Communication: "/communication",
        Disputes: "/disputes",
        BUYERCOMMUNICATION: "/buyer/:id/communications",
        AUDITREPORTS: '/audit-report',
    },
    BOTTOM: {
        SETTINGS: "/settings",
        INFO: "/info",
    }

} 
